// src/components/Menu/UploadScreen.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { harmonateTokens as ht } from '../../theme/harmonateTokens';
import {
  harmonatePageSx,
  harmonatePageTitleSx,
  harmonateCardSx,
  harmonateProceedButtonSx,
  harmonateCancelButtonSx,
} from '../../theme/harmonateStyles';

const UploadScreen = () => {
  const navigate = useNavigate();

  const fileStatusData = [
    { gl: 'GL to Efront', date: '3/12/25', id: 'Lance Lex, LP', status: 'Complete' },
    { gl: 'GL to Allvue', date: '3/17/25', id: 'Cooke Energy, LP', status: 'Complete' },
    { gl: 'GL to Investran', date: '6/29/25', id: 'Able Heights, LP', status: 'Complete' },
    { gl: 'GL to Efront', date: '9/11/25', id: 'Able Heights, LP', status: 'Complete' },
    { gl: 'GL to Paxus', date: '11/25/25', id: 'Able Heights 1, LP', status: 'Complete' },
    { gl: 'GL to Efront', date: '2/16/25', id: 'Cooke Lex, LP', status: 'Complete' },
    { gl: 'GL to Investran', date: '6/29/25', id: 'Able Heights, LP', status: 'Complete' },
  ];

  const handleNewFileUploadClick = () => {
    console.log("Navigating to /gl-sync/sync-upload");
    navigate('/gl-sync/sync-upload');
  };

  return (
    <Box sx={harmonatePageSx}>
      <Typography variant="h6" sx={{ ...harmonatePageTitleSx, mb: 2 }}>
        Files
      </Typography>

      <TableContainer component={Paper} elevation={0} sx={{ ...harmonateCardSx, mb: 4, bgcolor: ht.white }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow sx={{ '& th': { fontWeight: 'normal', color: ht.text, borderBottom: `1px solid ${ht.line}` } }}>
              <TableCell>GL</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>ID Term</TableCell>
              <TableCell>Process Step</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fileStatusData.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.gl}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.id}</TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2">{row.status}</Typography>
                    {row.status === 'Complete' && (
                      <Box sx={{ color: ht.green }}>
                        <CircularProgress variant="determinate" value={100} size={20} thickness={5} />
                      </Box>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button 
          variant="contained" 
          startIcon={<CloudUploadIcon />}
          sx={harmonateProceedButtonSx}
          onClick={handleNewFileUploadClick}
        >
          New File Upload
        </Button>
        <Button 
          variant="outlined" 
          endIcon={<KeyboardArrowUpIcon />}
          sx={{ 
            ...harmonateCancelButtonSx,
            bgcolor: ht.listBg,
            '&:hover': { bgcolor: ht.line, borderColor: ht.text },
          }}
        >
          Q2 2025
        </Button>
      </Box>
    </Box>
  );
};

export default UploadScreen;